import { useFieldValue } from "hooks";
import { useSelector } from "react-redux";
import { getBusinessById } from "selectors";
import { Row } from "components/Layout";
import { SubtleBadge } from "components/Badge";
import { CollapseLabel } from "components/Form";
import React from "react";
import { ValueSource } from "constants/ruleBooks";
import { getPropertyDisplayName } from "containers/Settings/RuleBooks/Schema/schema";

function getBusinessField(dataSource): string {
  if (dataSource.value) {
    return `${dataSource.value.replace(/_id$/, "")}`;
  }
  return "";
}

function toFriendlyBusinessName(dataSource): string {
  if (!dataSource) {
    return "";
  }
  if (
    dataSource.source === ValueSource.GLOBAL_BUSINESS ||
    dataSource.source === ValueSource.CONSTANT
  ) {
    return `${dataSource.value}`;
  }
  if (dataSource.source === ValueSource.FIELD) {
    return `${getPropertyDisplayName(getBusinessField(dataSource))}`;
  }
  return "";
}

export function ToFromHeader() {
  const fromBusiness = useFieldValue("from_business");
  const toBusiness = useFieldValue("to_business");
  const toBusinessValue = toFriendlyBusinessName(toBusiness);
  const fromBusinessValue = toFriendlyBusinessName(fromBusiness);
  const constantFromBusiness = useSelector(
    getBusinessById(fromBusiness && fromBusiness.value),
  );
  const constantToBusiness = useSelector(
    getBusinessById(toBusiness && toBusiness.value),
  );

  const toBusinessName = constantToBusiness
    ? constantToBusiness.name
    : toBusinessValue;
  const fromBusinessName = constantFromBusiness
    ? constantFromBusiness.name
    : fromBusinessValue;

  return (
    <Row>
      <div>
        <SubtleBadge>From/To</SubtleBadge>
      </div>
      <Row alignCenter flexWrap>
        <CollapseLabel>
          {toBusinessName} -&gt; {fromBusinessName}
        </CollapseLabel>
      </Row>
    </Row>
  );
}
